module.exports = __webpack_public_path__ + "img/lidere-se.747bc8d2.jpg";